import React from "react";
import logo from "../../assets/Image/logo.svg";

function InvalidDynamicId() {
    return (
        <>
            <div className="bgadminmob">
                <section className="bgloginsuper-admin bg_otp m-top25 commonipadbg loginipad-bg">
                    <div className="container">
                        <div className="logo-w">
                            {/* <Link to="/signin"> */}
                                <img src={logo} className="logo" alt="logo" />
                            {/* </Link> */}
                        </div>
                        <div className="row top63">
                            <div className="forgot">
                                <div className="icon-aut">
                                    <h2 className="otp-heading">Invalid Company</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p className="Powered-by">© Powered By Neocogita</p>
                </section>

            </div>
        </>
    )
}
export default InvalidDynamicId;